import {
  parseAsString,
  parseAsStringEnum,
  createLoader,
  parseAsArrayOf,
  parseAsInteger
} from 'nuqs/server';

import { DEFAULT_SORT_OPTION, SortOptionEnum } from '@/fo/ui/article/list/base';

export const blogSearchParams = {
  sort: parseAsStringEnum(Object.values(SortOptionEnum)).withDefault(
    DEFAULT_SORT_OPTION
  ),
  categories: parseAsArrayOf(parseAsString).withDefault([]),
  query: parseAsString.withDefault(''),
  p: parseAsInteger.withDefault(1)
};

export const loadBlogSearchParams = createLoader(blogSearchParams);
